(function($, HIS) {

	HIS.User = {
		resetStateUI:function(hide) {
			var stateDropdown = $('#state');
			stateDropdown.find('option').remove();
			stateDropdown.append($('<option></option>').text("Select State").val("")).val("");
			if (hide) stateDropdown.hide();
		},

		refreshStateOptions:function() {
			$.ajax({
				context: HIS.User,
				url: '/api/v1/countries/states',
				error: function(e) {
					console.log("Failed to fetch list of states");
					this.resetStateUI(true);
				},
				methodType: 'GET',
				data: { id: $('#country').val() },
				success: function(data){
					var states = data;
					var stateDropdown = $('#state');
					this.resetStateUI(states == '');
					if (states != '') {
						$.each(states, function(key, value) {
							stateDropdown.append($('<option></option>').text(value).val(key));
						});
						stateDropdown.show();
					}
				}
			});
		},

		init:function() {
			$('#country').change(this.refreshStateOptions);
		}
	};

	$(document).ready(function(){
		HIS.User.init();
	});

})(jQuery, this.HIS);
